import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router =  new Router({
    routes: [
        {
            path: '/',
            redirect:'/home'
        },
        {
            path: '/home',
            name: 'home',
            component: require('@/components/home').default,
        },
        {
            path: '/mains',
            name: 'mains',
            component: require('@/components/mains').default,
            children: [
                {
                    path: '/mains',
                    name: 'mainInfo',
                    component: require('@/components/mainPage/mainInfo').default
                },
                {
                    path: '/member',
                    name: 'member',
                    component: require('@/components/member/member').default,
                    children: [
                        {
                            path: '/member',
                            name: 'memberInfo',
                            component: require('@/components/member/memberInfo').default
                        },
                        {
                            path: '/memberDetails',
                            name: 'memberDetails',
                            component: require('@/components/member/memberDetails').default
                        },
                        {
                            path: '/memberAdd',
                            name: 'memberAdd',
                            component: require('@/components/member/memberAdd').default
                        },
                        {
                            path: '/memberChange',
                            name: 'memberChange',
                            component: require('@/components/member/memberChange').default
                        },
                        {
                            path: '/memberManage',
                            name: 'memberManage',
                            component: require('@/components/member/memberManage').default
                        },
                    ]
                },
                {
                    path: '/myBusiness',
                    name: 'myBusiness',
                    component: require('@/components/myBusiness/myBusiness').default,
                    children: [
                        {
                            path: '/myBusiness',
                            name: 'myBusinessInfo',
                            component: require('@/components/myBusiness/myBusinessInfo').default
                        },
                        {
                            path: '/permission ',
                            name: 'permission',
                            component: require('@/components/permission/permission').default
                        },
                        {
                            path: '/routeAdd ',
                            name: 'routeAdd',
                            component: require('@/components/permission/routeAdd').default
                        },
                    ]
                },
                {
                    path: '/addInvoice',
                    name: 'addInvoice',
                    component: require('@/components/myBusiness/addInvoice').default,
                },
            ]
        },
        {
            path: '/homeIndex',
            name: 'homeIndex',
            component: require('@/components/homeIndex').default,
            children: [
                    {
                        path: '/activation',
                        name: 'activation',
                        component: require('@/components/activation/activation').default
                    }
                ]
        },
        {
            path: '/login',
            name: 'login',
            component: require('@/components/login').default,
        },
        {
            path: '/signIn',
            name: 'signIn',
            component: require('@/components/signIn').default,
        },
        {
            path: '/free',
            name: 'free',
            component: require('@/components/free').default,
        },
        {
            path: '*',
            component: require('@/components/404').default,
        }
    ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js